import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import MailOutlinedIcon from '@mui/icons-material/MailOutlined';

import { Section } from '../components/Section/Section';


export const Help = () => {
  return (
    <Box>
      <Stack gap={2} alignItems="center">
        <Typography variant="h4" color="textSecondary" textAlign="center">
          If you have questions, need help, or feel unsure at any point, you're not alone.
        </Typography>
        <Typography color="textSecondary">
          You can:
        </Typography>
      </Stack>
      <Stack gap={2} my={4}>
        <Section
          icon={MailOutlinedIcon}
          title="Reach our team anytime by email"
          subtitle="We do our best to respond quickly and with care."
        >
          <div>
            <Button
              startIcon={<MailOutlinedIcon />}
              variant="outlined"
              component="a"
              href="mailto:danapaul@lgcypet.com"
            >
              danapaul@lgcypet.com
            </Button>
          </div>
        </Section>
      </Stack>
      <Typography variant="body2" color="textSecondary" textAlign="center">
        Take your time. There's no rush here.
      </Typography>
    </Box>
  );
};
